<template>
  <teleport to="body">
    <transition name="modal-fade">
      <div
        v-if="aberto"
        class="base-modal__mask"
        @click.self="fecharPeloFundo && fechar()"
      >
        <div
          class="base-modal__caixa"
          :class="tamanho ? `base-modal__caixa--${tamanho}` : ''"
          role="dialog"
          aria-modal="true"
          :aria-label="tituloAcessivel"
        >
          <button
            type="button"
            class="base-modal__fechar"
            aria-label="Fechar"
            @click="fechar"
          >
            &times;
          </button>
          <slot></slot>
        </div>
      </div>
    </transition>
  </teleport>
</template>

<script>
export default {
  name: 'BaseModal',
  props: {
    aberto: { type: Boolean, required: true },
    tituloAcessivel: { type: String, default: 'Janela' },
    fecharPeloFundo: { type: Boolean, default: true },
    tamanho: { type: String, default: '' }, // '' | 'lg'
  },
  emits: ['fechar'],
  watch: {
    aberto(valor) {
      // Trava o scroll da página por trás enquanto o modal está aberto.
      document.body.classList.toggle('modal-aberto', valor);
      if (valor) window.addEventListener('keydown', this.aoTeclar);
      else window.removeEventListener('keydown', this.aoTeclar);
    },
  },
  beforeUnmount() {
    document.body.classList.remove('modal-aberto');
    window.removeEventListener('keydown', this.aoTeclar);
  },
  methods: {
    fechar() {
      this.$emit('fechar');
    },
    aoTeclar(evento) {
      if (evento.key === 'Escape') this.fechar();
    },
  },
};
</script>

<style scoped>
.base-modal__mask {
  position: fixed;
  inset: 0;
  z-index: 10000; /* acima do balão de atendimento (9999) */
  background: rgba(15, 15, 20, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.base-modal__caixa {
  position: relative;
  background: #fff;
  border-radius: 12px;
  width: 100%;
  max-width: 460px;
  max-height: calc(100vh - 40px);
  overflow-y: auto;
  padding: 32px 28px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
}
.base-modal__caixa--lg {
  max-width: 640px;
}

.base-modal__fechar {
  position: absolute;
  top: 12px;
  right: 12px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 0;
  background: #f2f2f2;
  color: #444;
  font-size: 20px;
  line-height: 1;
  cursor: pointer;
}
.base-modal__fechar:hover {
  background: #e6e6e6;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.18s ease;
}
.modal-fade-enter-from,
.modal-fade-leave-to {
  opacity: 0;
}
.modal-fade-enter-active .base-modal__caixa,
.modal-fade-leave-active .base-modal__caixa {
  transition: transform 0.18s ease;
}
.modal-fade-enter-from .base-modal__caixa,
.modal-fade-leave-to .base-modal__caixa {
  transform: translateY(12px) scale(0.98);
}

@media (max-width: 480px) {
  .base-modal__caixa {
    padding: 24px 18px;
  }
}
</style>

<style>
/* Não-scoped de propósito: precisa afetar o <body> global enquanto o
   modal está aberto (impede rolagem da página por trás). */
body.modal-aberto {
  overflow: hidden;
}
</style>
